import { mergeStyles, getTheme } from '@fluentui/react';
import { IvicosColors } from 'kits/colorKit';

const theme = getTheme();

export const styles = {
    container: mergeStyles({
        height: '87vh',
        width: '100%',
        position: 'relative',
        overflow: 'hidden'
    }),
    top: mergeStyles({
        height: '58vh',
        width: '100%',
        backgroundColor: IvicosColors.Grau100,
        position: 'relative',
        overflow: 'hidden',
        '&:hover .upload-overlay': {
            opacity: 1
        }
    }),
    bottom: mergeStyles({
        height: '29vh',
        width: '100%',
        backgroundColor: IvicosColors.Grau75,
        position: 'relative',
        overflow: 'hidden',
        '&:hover .upload-overlay': {
            opacity: 1
        }
    }),
    image: mergeStyles({
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: 0,
        left: 0,
        transition: 'opacity 0.3s'
    }),
    imageContainer: mergeStyles({
        position: 'relative',
        width: '100%',
        height: '100%'
    }),
    navButton: mergeStyles({
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        // zIndex: 5,
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '50%',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.9)'
        }
    }),
    leftNav: mergeStyles({
        left: theme.spacing.m
    }),
    rightNav: mergeStyles({
        right: theme.spacing.m
    })
};
